<div class="relative z-10 w-full max-w-105 rounded-2xl border border-border bg-card p-10 shadow-2xl">
  <!-- Centered Logo -->
  <div class="mb-6 flex flex-col items-center">
    <!-- <a routerLink="/" class="login-brand btn-link"> -->
      <div class="flex items-center gap-3">
        <img src="main_money_square.png" alt="MainMoney" class="size-12 rounded-md object-contain" />
        <span class="text-[1.75rem] font-bold tracking-tight text-fg">Main Money</span>
      </div>
      <span class="mt-1 text-xs tracking-[0.3em] text-muted uppercase">Aggregator</span>
    <!-- </a> -->
  </div>

  <p class="m-0 mb-8 text-center text-base text-muted">Sign in to your admin account</p>

  @if (!otpRequired()) {
  <form (ngSubmit)="onSubmit()" class="flex flex-col gap-5">
    @if (merchantRedirectUrl()) {
      <ui-alert variant="warning" class="mb-0!">
        <div class="flex items-center gap-2 font-semibold">
          <ng-icon name="lucideCircleAlert" size="20" />
          <span>{{ error() || 'Merchant Account Detected' }}</span>
        </div>
        <p class="m-0 mt-2 mb-3 text-[0.8125rem] leading-snug">
          This portal is reserved for aggregator system administrators. Please sign in through the Merchant Portal.
        </p>
        <button type="button" uiButton variant="primary" size="sm" class="bg-warning! hover:bg-warning-fg!" (click)="goToMerchantPortal()">
          <span>Go to Merchant Portal</span>
          <ng-icon name="lucideLogOut" size="18" />
        </button>
      </ui-alert>
    } @else if (error()) {
      <ui-alert variant="danger" class="mb-0!">
        <div class="flex items-center gap-2"><ng-icon name="lucideCircleAlert" size="18" />
        <span>{{ error() }}</span></div>
      </ui-alert>
    }
    @if (info()) {
      <ui-alert variant="info" class="mb-0!">
        <div class="flex items-center gap-2"><ng-icon name="lucideCircleAlert" size="18" />
        <span>{{ info() }}</span></div>
      </ui-alert>
    }
    <label class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-fg">Username</span>
      <div class="group relative flex items-center">
        <ng-icon name="lucideUser" size="18" class="pointer-events-none absolute left-4 text-muted transition-colors group-focus-within:text-fg" />
        <input uiInput class="py-3.5! pr-4! pl-11! text-base!" type="text" [(ngModel)]="username" name="username" autocomplete="username" placeholder="Enter your username" />
      </div>
    </label>
    <label class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-fg">Password</span>
      <div class="group relative flex items-center">
        <ng-icon name="lucideLock" size="18" class="pointer-events-none absolute left-4 text-muted transition-colors group-focus-within:text-fg" />
        <input uiInput class="py-3.5! pr-4! pl-11! text-base!" type="password" [(ngModel)]="password" name="password" autocomplete="current-password" placeholder="Enter your password" />
      </div>
    </label>
    <div class="-mt-1 text-right text-sm">
      <a routerLink="/forgot-password" class="font-semibold text-info-fg no-underline hover:underline">Forgot password?</a>
    </div>
    <app-turnstile #turnstileWidget [(token)]="turnstileToken" />
    <button type="submit" uiButton variant="primary" size="lg" class="mt-2 font-bold" [disabled]="loading() || !turnstileToken">
      @if (loading()) {
        <ng-icon name="lucideRefreshCw" size="18" class="animate-spin" />
        <span>Signing in…</span>
      } @else {
        <ng-icon name="lucideLogOut" size="18" />
        <span>Sign in</span>
      }
    </button>
  </form>
  } @else {
  <form (ngSubmit)="onVerifyOtp()" class="flex flex-col gap-5">
    @if (merchantRedirectUrl()) {
      <ui-alert variant="warning" class="mb-0!">
        <div class="flex items-center gap-2 font-semibold">
          <ng-icon name="lucideCircleAlert" size="20" />
          <span>{{ error() || 'Merchant Account Detected' }}</span>
        </div>
        <p class="m-0 mt-2 mb-3 text-[0.8125rem] leading-snug">
          This portal is reserved for aggregator system administrators. Please sign in through the Merchant Portal.
        </p>
        <button type="button" uiButton variant="primary" size="sm" class="bg-warning! hover:bg-warning-fg!" (click)="goToMerchantPortal()">
          <span>Go to Merchant Portal</span>
          <ng-icon name="lucideLogOut" size="18" />
        </button>
      </ui-alert>
    } @else if (error()) {
      <ui-alert variant="danger" class="mb-0!">
        <div class="flex items-center gap-2"><ng-icon name="lucideCircleAlert" size="18" />
        <span>{{ error() }}</span></div>
      </ui-alert>
    }
    @if (info()) {
      <ui-alert variant="info" class="mb-0!">
        <div class="flex items-center gap-2"><ng-icon name="lucideCircleAlert" size="18" />
        <span>{{ info() }}</span></div>
      </ui-alert>
    }
    @if (otpMaskedDestination()) {
      <p class="m-0 text-sm text-fg-secondary">We sent an OTP code to {{ otpMaskedDestination() }}.</p>
    }
    <div class="flex flex-col gap-3">
      <span class="text-sm font-semibold text-fg">OTP code</span>
      <ui-otp-input
        [(code)]="otpCode"
        [autoFocus]="true"
        [invalid]="!!error()"
        [disabled]="loading()"
        label="OTP code"
        (completed)="onVerifyOtp()"
      />
    </div>
    <button type="submit" uiButton variant="primary" size="lg" class="mt-2 font-bold" [disabled]="loading() || otpCode.length < 6">
      @if (loading()) {
        <ng-icon name="lucideRefreshCw" size="18" class="animate-spin" />
        <span>Verifying…</span>
      } @else {
        <ng-icon name="lucideLogOut" size="18" />
        <span>Verify OTP</span>
      }
    </button>
  </form>
  }

  <div class="mt-7 flex items-center justify-center gap-2 border-t border-border pt-5 text-sm text-fg-secondary">
    <span>Are you a merchant?</span>
    <a [href]="merchantPortalUrl" class="font-semibold text-info-fg no-underline hover:underline">
      Sign in to Merchant Portal &rarr;
    </a>
  </div>
</div>
